import { every, sumBy } from 'lodash-es';
import { roundToNDecimalPlaces } from '@nx-ng/util';
import { Basket, BasketItem } from '../client/src';

export const isValidBasket = (basket?: Basket): boolean => {
  return (
    basket?.basketId !== undefined &&
    basketItemsAreValid(basket.basketItems) &&
    basket?.basketTotal ===
      sumBy(basket?.basketItems, (item: BasketItem) => item.subTotalPrice) &&
    basket?.totalItems ===
      sumBy(basket?.basketItems, (item: BasketItem) => item.quantity)
  );
};

export const basketItemsAreValid = (basketItems?: BasketItem[]): boolean => {
  if (!basketItems || basketItems.length === 0) {
    return false;
  }

  return every(
    basketItems,
    (item: BasketItem) =>
      item.ticketID !== undefined &&
      item.subTotalPrice > 0 &&
      item.price === roundToNDecimalPlaces(item.itemPrice * item.quantity, 0)
  );
};
